import { states } from '../data/locationData';

// Cache the fetched data to avoid multiple API calls
let countriesCache = null;

export async function getCountries() {
  if (countriesCache) {
    return countriesCache;
  }

  try {
    const response = await fetch(
      'https://restcountries.com/v3.1/all?fields=name,cca2'
    );
    const data = await response.json();

    // Format the data to match our needs
    const formattedCountries = data
      .map((country) => ({
        code: country.cca2,
        name: country.name.common,
      }))
      .sort((a, b) => a.name.localeCompare(b.name));

    countriesCache = formattedCountries;
    return formattedCountries;
  } catch (error) {
    console.error('Error fetching countries:', error);
    return [];
  }
}

// Get states/provinces for a given country code
export function getStates(countryCode) {
  return states[countryCode] || [];
}
